import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MessageService {
  private subject = new Subject<any>();

  setTheme(message: string) {
    this.subject.next({ text: message });
  }

  getTheme(): Observable<any> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/message.service/message.service.ts